import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import videoEditor from './modules/videoEditor'
import reelPlayer from './modules/reelPlayer'
import publishedReelPlayer from './modules/publishedReelPlayer'
import athleteProfile from './modules/athleteProfile'
import userData from './modules/userData'
import videoLibrary from './modules/videoLibrary'
import eventBeacon from './modules/eventBeacon'
import pricing from './modules/pricing'
import roster from './modules/roster'
import rostering from './modules/rostering'
import clubImport from './modules/clubImport'
import programNeeds from './modules/programNeeds'
import schoolSearch from './modules/schoolSearch'
import devTools from './modules/devTools';

export const rosterStore = new Vuex.Store({ modules: { roster } })

export default new Vuex.Store({
    modules: {
        videoEditor,
        reelPlayer,
        publishedReelPlayer,
        athleteProfile,
        userData,
        videoLibrary,
        roster,
        rostering,
        eventBeacon,
        pricing,
        clubImport,
        programNeeds,
        schoolSearch,
        devTools,
    },
})
